import React, { useCallback, useMemo } from 'react'
import { styled, SxProps, Theme } from '@mui/material/styles'

import TextField from 'components/global/CUK/TextField'

const StyledTextField = styled(TextField)(() => ({
  '& .MuiInputBase-input::placeholder': {
    color: '#95a4b2',
    fontStyle: 'normal',
  },
}))

interface TextFilterProps {
  placeholder: string
  value: string
  onChange: (value: string) => void
  sx?: SxProps<Theme>
  width?: string | number
}

const TextFilter = React.memo(({ placeholder, value, onChange, sx = {}, width = '35vh' }: TextFilterProps) => {
  const handleSetValue = useCallback((newValue: unknown) => {
    onChange(newValue as string)
  }, [onChange])

  const inputProps = useMemo(() => ({
    placeholder,
    starticon: <i className={'fa-light fa-search'} />,
  }), [placeholder])

  return (
    <StyledTextField
      value={value}
      setvalue={handleSetValue}
      sx={{ width, ...sx }}
      type="text"
      input={inputProps}
    />
  )
})

export default TextFilter

